import accountRoutes from './routes'

/* @ngInject */
const run = (
  $transitions,
  $$account
) => {
  $transitions.onSuccess({
    entering: accountRoutes.consult.path,
  }, (trans) => {
    $$account.request.getAll()
      .then((accounts) => {
        $$account.data.currents = accounts
      }, (error) => {
        if ($$account.data.currents)
          $$account.data.currents.splice(0, $$account.data.currents.length)
        // else
        //   $$account.data.currents = []
      })
  })
}

export default run



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/account/account.run.js